import React, { useContext } from 'react'
import './Badge.scss'
import { HeaderMenuContext } from '../../Components/Commons/HeaderMenu.Context'

export const Badge = () => {
    const { unreadMessageCount } = useContext(HeaderMenuContext)
    return !!unreadMessageCount && <div className="badge">{unreadMessageCount}</div>
}



// WEBPACK FOOTER //
// ./Src/Containers/Chat/Badge.js